<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">
      <div style="text-align: right;margin-top:40px; margin-right: 50px">
        <el-button v-if="this.type != 3 " @click="startCheck()">提交审核</el-button>
      </div>
      <div v-if="this.type === 4" style="margin-left:100px;">

        <div style="line-height:30px; color:red;">审核建议:</div>
        <div style="line-height:30px; width:250px" word-wrap="break-word" v-html="advice"></div>
      </div>
      <div class="title-box" v-html="title"></div>
      <!--      <el-button type="success" @click="admit">提交</el-button>-->
      <div class="date-box">发布时间：{{date}}</div>
      <div  class="date-box">
          <div style="display: inline-block;">关键词: <span v-html="'\u00a0\u00a0'"></span></div>
          <div style="display: inline-block;color:darkgreen"  v-for = "tag in dynamicTags">
            {{tag}}<span v-html="'\u00a0\u00a0'"></span>
          </div>

      </div>
      <div v-html="content" class="details-box"></div>
      <div class="zw">
        <table class="tabItem" style="margin-top: 40px;">
          <tbody>
          <tr>
            <th width="15%" style="text-align: center">成果类别<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="acType"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">解决的问题<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="solveQuestions"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">先进性<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="advancement"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">研究形式<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="researchForm"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">获奖情况<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="awards"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">市场前景分析<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="prospect"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">推广应用情况<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="application"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">经济效益<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="economicPerformance"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">社会生态效益<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="socialBenefits"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">可转化方式<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="convertibleMode"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">转化所需资金投入<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="needMoney+' 万元'"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">联系人<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="contact"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">联系地址<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="a=contactAddress"></div>
            </td>
          </tr>
          <tr>
            <th width="15%" style="text-align: center">联系电话<br>
            </th>
            <td colspan="3" style="text-align: left">
              <div v-html="contactNumber"></div>
            </td>
          </tr>


          </tbody>
        </table>
      </div>



    </div>


  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {

  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();
    this.tagInit();

  },
  data(){
    return{
      type:'',
      advice:'',
      id:null,
      date:'',
      content:'',
      title:'',

      tableData:[],
      dynamicTags: [],

      acType:'',
      solveQuestions:'',
      advancement:'',
      researchForm:'',
      awards:'',
      prospect:'',
      application:'',
      economicPerformance:'',
      socialBenefits:'',
      convertibleMode:'',
      needMoney:'',
      contact:'',
      contactAddress:'',
      contactNumber:'',

      fileList:[],
      CS: {
        'text-align': 'center',  //文本居中
        'min-width': '150px',   //最小宽度
        'word-break': 'break-all'  //过长时自动换行
      },
      LS: {
        'color': '#000',
        'text-align': 'center',
        'font-weight': '600',
        'height': '40px',
        'background-color': 'rgba(255, 97, 2, 0.1)',
        'min-width': '110px',
        'word-break': 'keep-all'
      }

    }
  },

  methods:{
    tagInit(){
      if(this.id == undefined)
      {
        return 1;
      }
      let data = {
        id:this.id,
        type:1,
      }
      let url = '/keyword/getKeywordByAchiId';
      this.$request.post(url,data).then(data =>{
        console.log("1111111111111111111111"+data);
        for (var i = 0; i < data.obj.length; i++) {
          this.dynamicTags[i] = data.obj[i].name;
        }
      })
    },
    startCheck(){
      let data={
        id:this.id,
        type:2,
      }
      this.$request.post('/PageNews/startCheck',data).then(data=>{
        console.log("success!");
        this.$message({
          type: 'success',
          message: '已提交审核'
        })
      },
      this.$router.push({
        path:'/myAchievement'
      })
      )
    },
    filter(){
      let data = {
        id:this.id,
      };
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      this.$request.post('/PageNews/getPageById',data).then(data => {
        console.log("111111111"+data);
        this.tableData=data.obj.news;
        this.type=data.obj.news.type;
        this.advice=data.obj.news.advice;
        this.title =  data.obj.news.title;
        this.content = data.obj.news.content;
        this.acType=data.obj.news.acType;
        this.solveQuestions=data.obj.news.solveQuestions;
        this.advancement=data.obj.news.advancement;
        this.researchForm=data.obj.news.researchForm;
        this.awards=data.obj.news.awards;
        this.prospect=data.obj.news.prospect;
        this.application=data.obj.news.application;
        this.economicPerformance=data.obj.news.economicPerformance;
        this.socialBenefits=data.obj.news.socialBenefits;
        this.convertibleMode=data.obj.news.convertibleMode;
        this.needMoney=data.obj.news.needMoney;
        this.contact=data.obj.news.contact;
        this.contactAddress=data.obj.news.contactAddress;
        this.contactNumber=data.obj.news.contactNumber;
        this.date = time.formateDate(data.obj.news.createdDate);
        console.log("111111111"+this.tableData);
        loadingInstance.close();
      })
    },
  }
}
</script>

<style lang="less">
.message-box{
  text-align: center;
  margin-top: 25px;
  font-size: 16px;
  line-height: 25px;
  .message-detail{
    display: inline-block;

  }
}
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: #000000; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .zw{

    font-size: 14px;

    border-collapse: collapse;
    .tabItem{
      background-color: #FFFFFF;
      border-collapse: collapse;
      border-color: #0e5c31 #87c21a #87c21a;
      border-style: solid;
      border-width: 3px 1px 1px;
      margin: 0 auto;
      padding: 0;
      width: 95%;
      font-size: 14px;
      th{
        background-color: #f4ffe0;
        background-image: none;
        border-color: #87c21a;
        border-style: solid;
        border-width: 0 1px 1px;
        padding: 8px 5px 6px;
      };
      td{

        border-color: #87c21a;
        border-style: solid;
        border-width: 0 1px 1px;
        padding: 5px 5px 1px;
      }
    }
  }
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 24px;
  }
  .details-box{
    margin-top: 25px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }

  }
  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>